<template>
	<header-menu-admin />

	<section class="error-section py-40" v-if="!item && !loading">
		<div class="container-fluid">
			<div class="error-wrapper text-center py-40 bg-white br-10">
				<h1 class="mb-32">404</h1>
				<h5 class="mb-16"><span class="color-primary">Упс!</span> Что-то пошло не так...</h5>
				<p class="light-gray mb-32">Новость не найдена.<br/>Возможно она была удалена либо никогда не существовала.</p>
				<router-link :to="{path: '/admin/news'}" class="cus-btn">В список новостей</router-link>
			</div>
		</div>
	</section>
	
	<div v-else>
		<!-- Main Sections -->
		<main class="main-wrapper bg-lightest-gray">

			<!-- About Section Start -->
			<section class="about-section py-40">
				<div class="container-fluid">
					<div class="top-bar mb-16">
						<router-link :to="{path: '/admin/news'}" class="btn btn-secondary">
							Назад
						</router-link>
					</div>
					<div class="about-wrapper bg-white">
						<div class="about-block">
							<h4 class="mb-12">Изменение новости</h4>
							<form @submit.prevent="onNewsItemEdit" class="contact-form">
								<div class="row">
									<div class="col-md-1">
										<div class="input-block mb-16">
											<label for="id" class="form-label">ID записи:</label>
											<input type="number" id="id" class="form-control" :value="item?.id" disabled>
										</div>
									</div>
									<div class="col-md-8">
										<div class="input-block mb-16">
											<label for="title" class="form-label">Заголовок:</label>
											<input type="text" id="title" class="form-control" placeholder="Заголовок" v-model="title" required>
										</div>
									</div>
									<div class="col-md-3">
										<div class="input-block mb-16">
											<label for="date" class="form-label">Дата:</label>
											<input type="datetime-local" id="date" class="form-control" placeholder="Дата" v-model="date" required>
										</div>
									</div>
									<div class="col-md-12">
										<div class="input-block mb-16">
											<label for="description" class="form-label">Текст новости:</label>
											<textarea id="description" cols="8" rows="5" class="form-control" placeholder="Текст новости" v-model="description" required></textarea>
										</div>
									</div>
									<div class="col-md-12">
										<div class="input-block mb-16">
											<label for="poster" class="form-label">Постер (если нужно изменить):</label>
											<input type="file" id="poster" class="form-control d-block" @change="handleFileChange">
										</div>
									</div>
									<div class="col-md-6">
										<button type="submit" class="btn btn-primary" :disabled="btnDisabled">Сохранить изменения</button>
									</div>
									<div class="col-md-6 text-end">
										<button type="button" class="btn btn-outline-danger" @click="onDelete">Удалить</button>
									</div>
								</div>
							</form>
							<div class="alert alert-warning alert-dismissible mt-3 mb-0" role="alert" v-if="error">
								{{error}}
								<button type="button" class="btn-close" aria-label="Close" @click="error = ''"></button>
							</div>
						</div>
					</div>
				</div>
			</section>
			<!-- About Section End -->
		</main>
		<!-- Main Sections -->
	</div>
</template>

<style lang="scss">
      
</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

import HeaderMenuAdmin from '@/components/HeaderMenuAdmin';

export default {
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'InterMagTech Admin'});
	},
	data: () => ({
		item: null,
		title: '',
		description: '',
		date: '',
		poster: '',
		
		loading: true,
		error: '',
		btnDisabled: false,
	}),
	methods: {
		handleFileChange(event){
			this.poster = event.target.files[0];
		},
		
		async loadNewsItem(){
			this.loading = true;
			this.appModel.preloader = true;
			
			const ret = await this.appModel.doGetNewsitem(this.$route.params.id);
			if(ret.success){
				this.item = ret.item;
				this.title = this.item?.title||'';
				this.description = this.item?.description||'';
				this.date = this.item?.date||'';
			}
			
			setTimeout(() => {
				this.loading = false;
				this.appModel.preloader = false;
			}, 1000);
		},
		async onNewsItemEdit(){
			this.error = '';
			this.btnDisabled = true;
			
			const params = {
				title: this.title,
				description: this.description,
				date: this.date,
				poster: this.poster,
			};
			const ret = await this.appModel.doEditNewsItem(this.$route.params.id, params);
			this.btnDisabled = false;
			if(ret.success){
				
			} else {
				this.error = ret.error;
			}
		},
		async onDelete(){
			if(confirm('Вы уверены, что хотите удалить данную новость?')){
				const ret = await this.appModel.doDeleteNewsItem(this.$route.params.id);
				if(ret.success){
					this.$router.push('/admin/news');
				} else {
					this.error = ret.error;
				}
			}
		},
	},
	async mounted(){
		window.scrollTo(0, 0);
		
		await this.loadNewsItem();
	},
	beforeRouteUpdate(to, from, next){
		window.scrollTo(0, 0);
		next();
	},
	components: {
		HeaderMenuAdmin,
	},
};
</script>